import { render, staticRenderFns } from "./connection-number.vue?vue&type=template&id=d52ace32&scoped=true"
import script from "./connection-number.vue?vue&type=script&lang=js"
export * from "./connection-number.vue?vue&type=script&lang=js"
import style0 from "./connection-number.vue?vue&type=style&index=0&id=d52ace32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_d79148f6156699cf80ef22aa45ce0a5c/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d52ace32",
  null
  
)

export default component.exports